export const STOP_PROP_TAG = 'allowRowEvents';
